import cx from 'classnames';
import pluralize from 'pluralize';
import { useEffect, useRef, useState } from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import { OrganizationButton } from "./OrganizationShared";
import OrganizationUserList from "./OrganizationUserList";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OrganizationUsersSummary(_ref) {
  let {
    className,
    org,
    ...rest
  } = _ref;
  if (!org.users) return null;
  const containerRef = useRef();
  const [userListVisible, setUserListVisible] = useState(false);
  useEffect(() => {
    const handleClick = event => {
      if (containerRef.current && event.target instanceof Node && !containerRef.current.contains(event.target)) setUserListVisible(false);
    };
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [userListVisible]);
  return /*#__PURE__*/_jsx("span", {
    className: cx('OrganizationUsersSummary', className),
    ...rest,
    ref: containerRef,
    "data-sentry-component": "OrganizationUsersSummary",
    "data-sentry-source-file": "OrganizationUsersSummary.tsx",
    children: org.users.length ? /*#__PURE__*/_jsxs(Manager, {
      children: [/*#__PURE__*/_jsx(Reference, {
        children: _ref2 => {
          let {
            ref
          } = _ref2;
          return /*#__PURE__*/_jsx(OrganizationButton, {
            onClick: () => setUserListVisible(!userListVisible),
            ref: ref,
            children: pluralize('user', org.users.length, true)
          });
        }
      }), userListVisible && /*#__PURE__*/_jsx(Popper, {
        modifiers: {
          flip: {
            behavior: ['bottom-end', 'bottom', 'left-start']
          },
          preventOverflow: {
            boundariesElement: 'viewport',
            padding: 20
          }
        },
        placement: "bottom-end",
        positionFixed: true,
        children: _ref3 => {
          let {
            arrowProps,
            placement,
            ref,
            style
          } = _ref3;
          return /*#__PURE__*/_jsx(OrganizationUserList, {
            arrowRef: arrowProps.ref,
            arrowStyle: arrowProps.style,
            innerRef: ref,
            placement: placement,
            style: style,
            users: org.users
          });
        }
      })]
    }) : /*#__PURE__*/_jsx(OrganizationButton, {
      disabled: true,
      children: "0 users"
    })
  });
}